import HubCore from 'hub-js'
import DefaultIcon from '@/assets/default-icon.png'

const dataCore = {
  environment: process.env.VUE_APP_CORE_ENV,
  theme: process.env.VUE_APP_THEME
}
const hubInstance = new HubCore(dataCore)

const actions = {
  SET_APPS ({ commit }, body) {
    return hubInstance.dev.app.getAll(body)
      .then(apps => {
        apps.isLoading = false
        apps.items = apps.items.map(e => {
          if (e.avatar !== undefined) {
            e.avatar = hubInstance.image.listById(e.avatar)
          } else {
            e.avatar = DefaultIcon
          }
          return e
        })
        return Promise.resolve(apps)
      })
      .catch((error) => {
        const apps = {
          items: [],
          paging: {
            navigator: {},
            options: {
              pageCount: 0,
              pageNumber: 0
            }
          },
          isLoading: false
        }
        commit('SET_APPS', apps)
        return Promise.reject(error)
      })
  },
  PAGINATE_APPS ({ commit, state, dispatch }, body) {
    return dispatch('SET_APPS', body)
      .then(apps => {
        const actualItems = Object.assign([], state.apps.items)
        apps.items = actualItems.concat(apps.items)
        commit('SET_APPS', apps)
        return apps
      })
  },
  LIST_APPS ({ commit, dispatch }, body) {
    return dispatch('SET_APPS', body)
      .then(apps => {
        commit('SET_APPS', apps)
        return apps
      })
  },
  GET_APP_DETAIL ({ commit }, publicAppKey) {
    hubInstance.dev.app.getDetail(publicAppKey)
      .then(app => {
        app.isLoading = false
        app.requestFailed = false
        commit('SET_APP_DETAIL', app)
      })
      .catch(response => {
        const mock = {
          additionalData: {
            type: '',
            required: [],
            properties: {}
          },
          classification: {},
          descriptions: [{ language: 'pt-br', shortDescription: '', fullDescription: '' }],
          banners: [],
          actions: [],
          events: [],
          optionalActions: [],
          optionalEvents: [],
          security: {
            hosts: []
          },
          isLoading: false,
          requestFailed: true
        }
        commit('SET_APP_DETAIL', mock)
      })
  },
  SET_APPLICATION_CATEGORIES ({ commit }) {
    hubInstance.app.getCategories()
      .then(response => {
        commit('SET_APPLICATION_CATEGORIES', response)
      })
  },
  CREATE_APP ({ commit }, body) {
    return hubInstance.dev.app.create(body)
  },
  GET_EVENTS ({ commit }) {
    hubInstance.dev.app.getEvents()
      .then(events => {
        commit('SET_EVENTS', events.items)
      })
  },
  GET_ACTIONS ({ commit }) {
    hubInstance.dev.app.getActions()
      .then(actions => {
        commit('SET_ACTIONS', actions.items)
      })
  },
  GET_REVIEW_ISSUES (context, publicAppKey) {
    return hubInstance.dev.app.getReviewIssues(publicAppKey)
  },
  UPDATE_GENERAL_DATA ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'general-data', body)
      .then(response => {
        commit('UPDATE_GENERAL_DATA', response)
        return response
      })
  },
  UPDATE_DESCRIPTIONS ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'descriptions', body)
      .then(response => {
        commit('UPDATE_DESCRIPTIONS', response.descriptions)
        return response
      })
  },
  UPDATE_CALLBACKS ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'callbacks', body)
      .then(response => {
        commit('UPDATE_CALLBACKS', response)
        return response
      })
  },
  UPDATE_PERMISSIONS ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'permissions', body)
      .then(response => {
        commit('UPDATE_PERMISSIONS', response)
        return response
      })
  },
  UPDATE_SECURITY ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'security', body)
      .then(response => {
        commit('UPDATE_SECURITY', response.security)
        return response
      })
  },
  UPDATE_ADDITIONAL_DATA ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'additional-data', body)
      .then(response => {
        commit('UPDATE_ADDITIONAL_DATA', response.additional_data)
        return response
      })
  },
  UPLOAD_AVATAR ({ commit }, file) {
    const body = new FormData()
    body.append('Image', file)
    return hubInstance.dev.image.createAvatar(body)
  },
  UPLOAD_BANNER ({ commit }, file) {
    const body = new FormData()
    body.append('Image', file)
    return hubInstance.dev.image.createBanner(body)
  },
  UPDATE_IMAGES ({ commit, state }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updatePartial(publicAppKey, 'images', body)
      .then(response => {
        commit('UPDATE_IMAGES', response)
        return response
      })
  },
  DELETE_APP ({ dispatch }, { publicAppKey, body }) {
    return hubInstance.dev.app.deleteDev(publicAppKey, body)
      .then(response => {
        dispatch('LIST_APPS', {})
        return response
      })
  },
  SUBMIT_REVIEW ({ state, dispatch }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.createReview(publicAppKey, body)
      .then(() => {
        dispatch('GET_APP_DETAIL', publicAppKey)
        return true
      })
  },
  AVALIATE_APP ({ state, dispatch }, body) {
    const publicAppKey = state.detail.public_app_key
    return hubInstance.dev.app.updateAvaliate(publicAppKey, body)
      .then(() => {
        dispatch('GET_APP_DETAIL', publicAppKey)
        return true
      })
  }
}

export default actions
